import styled from 'styled-components';

const ModalFooter = styled.div`
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 1rem;
`;

export default ModalFooter;



// WEBPACK FOOTER //
// client/components/Modal/ModalFooter.js